


















































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Video from "@/components/Video.vue";
import { BIcon, BIconBoxArrowRight } from "bootstrap-vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    Video,
    Footer,
    BIconBoxArrowRight,
    NextPrevBtn,
    BIcon,
  },
})
export default class PosterInspiration extends Vue {
  protected videoFont = [
    {
      videoSrc: "https://www.dailymotion.com/embed/video/x284c63",
      videoTitle: "Sacrés caractères - Futura",
      videoRoot: "Chaîne : France Culture",
    },
    {
      videoSrc: "https://www.dailymotion.com/embed/video/x284bzz",
      videoTitle: "Sacrés caractères - Times",
      videoRoot: "Chaîne : France Culture",
    },
    {
      videoSrc: "https://www.dailymotion.com/embed/video/x284c6l",
      videoTitle: "Sacrés caractères - Garamond",
      videoRoot: "Chaîne : France Culture",
    },
    {
      videoSrc: "https://www.dailymotion.com/embed/video/x284c9t",
      videoTitle: "Sacrés caractères - Comic Sans",
      videoRoot: "Chaîne : France Culture",
    },
    {
      videoSrc: "https://www.dailymotion.com/embed/video/x284c7s",
      videoTitle: "Sacrés caractères - Trajan",
      videoRoot: "Chaîne : France Culture",
    },
    {
      videoSrc: "https://www.dailymotion.com/embed/video/x284c2z",
      videoTitle: "Sacrés caractères - Cooper Black",
      videoRoot: "Chaîne : France Culture",
    },
    {
      videoSrc: "https://www.dailymotion.com/embed/video/x284c57",
      videoTitle: "Sacrés caractères - Bodoni",
      videoRoot: "Chaîne : France Culture",
    },
    {
      videoSrc: "https://www.dailymotion.com/embed/video/x284c8v",
      videoTitle: "Sacrés caractères - Transport",
      videoRoot: "Chaîne : France Culture",
    },
  ];
  protected nxtprevPosterInspiration = {
    BoolPrev: true,
    BoolNext: false,
    PrevImage: "/thumbnail1.png",
    NextImage: "",
    PrevLink: "/Affiche/EnPratique",
    NextLink: "",
  };
}
